// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'sectors-slider';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class SectorsSlider {
  constructor(el) {
    this.el = el;
    this.swiper = null;

    this.$swiperContainer = $(el).find('.swiper-container');
    this.$swiperPrev = $(el).find('.swiper-button-prev');
    this.$swiperNext = $(el).find('.swiper-button-next');

    this.initSlideshow();
  }

  async initSlideshow() {
    const {
      default: Swiper,
      Navigation: SwiperNavigation
    } = await import('swiper/core');

    Swiper.use([SwiperNavigation]);

    this.swiper = new Swiper(this.$swiperContainer[0], {
      // @see https://swiperjs.com/swiper-api

      breakpoints: {
        320: {
          slidesPerView: 'auto',
        },
        768: {
          slidesPerView: 2,
        },
        1200: {
          slidesPerView: 3,
        }
      },

      navigation: {
        prevEl: this.$swiperPrev[0],
        nextEl: this.$swiperNext[0],
      },
      speed: (1000 * (5 / 8)),
    });
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new SectorsSlider(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
